import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getOffices } from 'api/offices';
import LoadingOverlay from 'components/LoadingOverlay';
import Button from 'components/Button';

export default function Offices() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    const { data: offices, isLoading } = useQuery({
        queryKey: ['offices'],
        queryFn: async () => await getOffices({}),
    });

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to="/settings" className=''>
                                <CaretLeftIcon size={26} className='text-black hover:text-muted' />
                            </Link>
                            <p className='text-3xl '>Uffici</p>
                        </div>
                        <Button component={Link} to="/settings/offices/create">
                            Crea nuovo ufficio
                        </Button>
                    </div>

                    <div className=''>
                        <div className='border border-light rounded-sm'>
                            {offices?.map((office, index) => {
                                return (
                                    <Link to={`/settings/offices/${office._id}`} key={index} className='border-b last:border-0 border-light hover:bg-verylight flex items-center gap-4 p-4'>
                                        <div className='flex-1'>
                                            <p className='font-medium text-base'>{office.name}</p>
                                        </div>
                                        <div className='flex-2'>
                                            <p className='text-muted text-right'>{office.description}</p>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
